var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"py-2 font-size-xl btn btn-primary btn-block",attrs:{"tag":"button","to":_vm.checkoutLink}},[_c('span',[_vm._v(_vm._s(_vm.$t('goToCheckout')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }